// Pull WordPress-provided globals exactly as your app.js expects
// (wp_ajax_url, mapbox_key, mapbox_style, theme_url, env)
const g = (typeof window !== 'undefined' ? window : {});

export const wp_ajax_url = g.wp_ajax_url;
export const mapbox_key   = g.mapbox_key;
export const mapbox_style = g.mapbox_style;
export const theme_url    = g.theme_url;
export const env          = g.env || {};

// Your tiny helper: submit form and keep anchor usable for offset correction
export function submitFormWithAnchor(formID, anchorID) {
  const form = document.getElementById(formID);
  const baseAction = form.action.split('#')[0];
  form.action = baseAction + '#' + anchorID;
  try { sessionStorage.setItem('scrollHash', '#' + anchorID); } catch (e) {}
  form.submit();
}

// Keep global for current inline usage without hunting templates
window.submitFormWithAnchor = submitFormWithAnchor;
